module.exports = __webpack_public_path__ + "static/linkissues-61f0c817a3b380b4eca11630b80986f2.png";